module.exports = __webpack_public_path__ + "static/media/giide.7726b561.mp4";